"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleAnswerFromLearnosity = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var dompurify_1 = __importDefault(require("dompurify"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
// Sanitizing the HTML coming from Learnosity
var sampleAnswerFromLearnosity = function (html) {
    var sanitizeOptions = {
        ALLOWED_TAGS: [
            'b',
            'i',
            'u',
            'em',
            'strong',
            'span',
            'br',
            'p',
            'ul',
            'ol',
            'li',
            'table',
            'thead',
            'tbody',
            'tr',
            'td',
            'th',
            'a',
            'img',
            'blockquote',
            'code',
            'pre',
            'math',
            'mi',
            'mn',
            'mo',
            'mrow',
            'msup',
            'msub',
            'mfrac',
        ],
        ALLOWED_ATTR: [
            'href',
            'target',
            'src',
            'alt',
            'title',
            'style',
            'width',
            'height',
            'class',
            'xmlns',
            'mathvariant',
        ],
    };
    var sanitizeHtml = dompurify_1.default.sanitize(html, sanitizeOptions);
    return ((0, jsx_runtime_1.jsx)("div", { className: "sample-label", children: (0, html_react_parser_1.default)(sanitizeHtml) }));
};
exports.sampleAnswerFromLearnosity = sampleAnswerFromLearnosity;
